// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media parameters */
/* Colors */
/* Fonts */
.Select_select__rFOwa {
  display: flex;
  flex-grow: 1;
  position: relative;
  cursor: pointer;
}

.Select_selected-option__PU3qK {
  font-size: 16px;
  line-height: 110%;
  display: flex;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #8000FF;
  background-color: #FFFFFF;
  transition: all 0.5s;
  width: 100%;
  overflow: hidden;
}
.Select_selected-option-text__yZQXi {
  flex-grow: 1;
}

.Select_options__nvDAn {
  position: absolute;
  bottom: -16px;
  transform: translateY(100%) translateX(-50%);
  left: 50%;
  width: 90%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 15px rgba(5, 0, 255, 0.2509803922);
  background-color: #FFFFFF;
  border-radius: 10px;
  z-index: 10;
}

.Select_option__ricdm {
  cursor: pointer;
  display: flex;
  padding: 8px;
}
.Select_option__ricdm:hover {
  background-color: rgba(5, 0, 255, 0.062745098);
}
.Select_option__ricdm:first-child {
  border-radius: 10px 10px 0 0;
}
.Select_option__ricdm:last-child {
  border-radius: 0 0 10px 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.sass","webpack://./src/components/form/newSelect/Select.module.sass","webpack://./src/assets/styles/mixins.sass"],"names":[],"mappings":"AAAA,qBAAA;AASA,WAAA;AAWA,UAAA;ACjBA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACF;;AACA;ECFI,eAAA;EACA,iBAAA;EDGF,aAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,yBDLW;ECMX,oBAAA;EACA,WAAA;EACA,gBAAA;AAGF;AADE;EACE,YAAA;AAGJ;;AADA;EACE,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;EACA,yBDtBW;ECuBX,mBAAA;EACA,WAAA;AAIF;;AAFA;EACE,eAAA;EACA,aAAA;EACA,YAAA;AAKF;AAHE;EACE,8CAAA;AAKJ;AAHE;EACE,4BAAA;AAKJ;AAHE;EACE,4BAAA;AAKJ","sourcesContent":["/* Media parameters */\r\n$mobile-max: 768px\r\n$tablet-max: 1210px\r\n$desktop-max: 1440px\r\n\r\n// Отступы от краев экрана\r\n$mobile-offset: 8px\r\n$desktop-offset: 64px\r\n\r\n/* Colors */\r\n$base-white: #FFFFFF\r\n$base-black: #333333\r\n$base-shadow: #0500FF40\r\n$accent: #8000FF\r\n$accent-darken: #6000BF\r\n$link: #007AFF\r\n$error: #D60056\r\n// Также отвечает и за disabled\r\n$placeholder: #33333360\r\n\r\n/* Fonts */\r\n$fm-primary: 'Roboto Mono', 'Arial', monospace","@use \"../../../assets/styles/variables\" as *\r\n@use \"../../../assets/styles/mixins\" as mix\r\n\r\n.select\r\n  display: flex\r\n  flex-grow: 1\r\n  position: relative\r\n  cursor: pointer\r\n\r\n.selected-option\r\n  @include mix.text-2\r\n  display: flex\r\n  padding: 8px\r\n  border: none\r\n  border-bottom: 1px solid $accent\r\n  background-color: $base-white\r\n  transition: all 0.5s\r\n  width: 100%\r\n  overflow: hidden\r\n\r\n  &-text\r\n    flex-grow: 1\r\n\r\n.options\r\n  position: absolute\r\n  bottom: -16px\r\n  transform: translateY(100%) translateX(-50%)\r\n  left: 50%\r\n  width: 90%\r\n  display: flex\r\n  flex-direction: column\r\n  box-shadow: 0 2px 15px $base-shadow\r\n  background-color: $base-white\r\n  border-radius: 10px\r\n  z-index: 10\r\n\r\n.option\r\n  cursor: pointer\r\n  display: flex\r\n  padding: 8px\r\n  \r\n  &:hover\r\n    background-color: #0500FF10\r\n\r\n  &:first-child\r\n    border-radius: 10px 10px 0 0\r\n  \r\n  &:last-child\r\n    border-radius: 0 0 10px 10px","@use \"./variables\" as *\r\n\r\n@mixin text-1\r\n    font-size: 20px\r\n    line-height: 120%\r\n\r\n@mixin text-2\r\n    font-size: 16px\r\n    line-height: 110%\r\n\r\n@mixin text-3\r\n    font-size: 12px\r\n    line-height: 110%\r\n\r\n@mixin container\r\n    max-width: $desktop-max\r\n    margin: 0 auto\r\n    width: calc(100vw - $desktop-offset * 2)\r\n\r\n    @media (max-width: $mobile-max)\r\n        width: calc(100vw - $mobile-offset * 2)\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `Select_select__rFOwa`,
	"selected-option": `Select_selected-option__PU3qK`,
	"selected-option-text": `Select_selected-option-text__yZQXi`,
	"options": `Select_options__nvDAn`,
	"option": `Select_option__ricdm`
};
export default ___CSS_LOADER_EXPORT___;
